import { BasketPackageMeal, BasketSetMeal, CollectiveItem } from '../interfaces/collective-dish-panel.interface';

export function isCollectiveItemIsBasketPackageMeal(val: CollectiveItem): val is BasketPackageMeal {
    return val.dish_type === '1';
}

export function isCollectiveItemIsBasketSetMeal(val: CollectiveItem): val is BasketSetMeal {
    return val.dish_type === '2';
}